import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router";
import { useSite } from "../hooks/useSite";
import { useSiteMutations } from "../hooks/useSiteMutations";
import { toast } from "react-toastify";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { TextField } from "@mui/material";
import { SaveButton } from "../../../../components";
import { SiteActivesStockage } from "./grids/SiteActivesStockage";
import { SiteWaybills } from "./grids/SiteWaybills";
import { SiteInvoices } from "./grids/SiteInvoices";

export const SiteFormView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [sede, setSede] = useState({});
  const { getSede } = useSite();
  const { createSede, updateSede } = useSiteMutations();
  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
  } = useForm();

  useEffect(() => {
    if (id) {
      getSede({ variables: { id } })
        .then(({ data }) => {
          if (data?.sede) {
            setSede(data.sede);
            setValue("nombre", data.sede.nombre);
          }
        })
        .catch((error) => {
          toast.error(error.message);
        });
    }
  }, [id]);

  const isFocused = (field) => {
    return id !== undefined && sede[field] !== undefined && sede[field] !== "";
  };

  const onSubmit = (formData) => {
    console.log("formData", id);
    if (!id) {
      createSede({ variables: { data: { ...formData } } })
        .then(({ data }) => {
          if (data.createSede.ok) {
            toast.info("Sede creado");
            navigate("/sites", { replace: true });
          } else {
            toast.error("Error al crear la sede");
          }
        })
        .catch((error) => {
          toast.error(error.message);
        });
    } else {
      updateSede({ variables: { id, data: { ...formData } } })
        .then(({ data }) => {
          if (data.updateSede.ok) {
            toast.info("Sedeactualizado");
          } else {
            toast.error("Error al actualizar la sede");
          }
        })
        .catch((error) => {
          toast.error(error.message);
        });
    }
  };

  return (
    <Container fluid={true}>
      <Row>
        <Col sm="12" md="6">
          <Row>
            <Col sm="12">
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="mb-3">
                      <Col sm="12">
                        <h6>{id ? "Editar" : "Nuevo"} sede</h6>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <TextField
                          fullWidth
                          size="small"
                          label="NOMBRE"
                          name="nombre"
                          {...register("nombre", { required: true })}
                          helperText={errors.nombre && "El nombre es requerido"}
                          error={errors.nombre ? true : false}
                          focused={isFocused("nombre")}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col className="d-flex justify-content-end">
                        <SaveButton />
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Col>

        {id && (
          <Col sm="12">
            <SiteActivesStockage stock={sede?.activostockageSet} />
          </Col>
        )}
        {id && (
          <Col sm="12">
            <SiteWaybills waybills={sede?.albaranSet} />
          </Col>
        )}
        {id && (
          <Col sm="12">
            <SiteInvoices invoices={sede?.facturaSet} />
          </Col>
        )}
      </Row>
    </Container>
  );
};
